module.exports = __webpack_public_path__ + "static/assets/024507e8b79fbf8420df9be80b2d1911.svg";